import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/components/ui/table";
import type { TmsTokenRow } from "../types/tokens-types";

export function TmsTokenDetailsDialog({
    open,
    onOpenChange,
    tokens,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    tokens: TmsTokenRow[];
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-4xl">
                <DialogHeader>
                    <DialogTitle>토큰 정보</DialogTitle>
                </DialogHeader>

                <div className="rounded-md border overflow-x-auto">
                    <Table className="min-w-[700px]">
                        <TableHeader>
                            <TableRow>
                                <TableHead>키</TableHead>
                                <TableHead>값</TableHead>
                                <TableHead>업데이트 시각</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {tokens.map((t) => (
                                <TableRow key={t.key}>
                                    <TableCell>{t.key}</TableCell>
                                    <TableCell className="font-mono">{t.value}</TableCell>
                                    <TableCell>{t.updatedAt ?? "-"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </DialogContent>
        </Dialog>
    );
}